import { computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { FindAllProveedorSelectAction } from "../../actions/proveedorActions/FindAllSelectProveedorAction";

export function useProveedorSelect() {
  
  const query = useQuery({
    queryKey: ["ProveedoresList"],
    queryFn: () => FindAllProveedorSelectAction(),
    staleTime: 60 * 1000,
  });

  const Proveedor = computed(() => query.data.value?.data?.data || []);

  return {
    ...query,
    Proveedor,
  };
}
